import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-home\">\n<path id=\"icon-home_首页\" d=\"M17.2,9l-5.8-6.1c-0.7-0.8-1.9-0.8-2.7-0.1c0,0,0,0-0.1,0.1L2.8,9c-0.4,0.3-0.6,0.9-0.4,1.4\n\tc0.2,0.4,0.6,0.6,1,0.6h0.9v4.7c-0.1,1.1,0.8,2,1.8,2.1h2.5v-5c0-0.5-0.1-0.8,0.5-0.8h2c0.5,0,0.5,0.3,0.5,0.8v5h2.5\n\tc1.1-0.1,1.9-1,1.8-2.1V11h0.9c0.4,0,0.8-0.2,1-0.6C17.8,9.9,17.6,9.3,17.2,9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 97